import script from "./Application.vue?vue&type=script&setup=true&lang=ts"
export * from "./Application.vue?vue&type=script&setup=true&lang=ts"

import "./Application.vue?vue&type=style&index=0&id=2ed8be9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed8be9d"]])

export default __exports__